module.exports = __webpack_public_path__ + "img/icon_NCDs_A04_af.3c1ebcee.png";